export default "__VITE_ASSET__D6z0wao___"